import React, { createContext, useState, useContext, ReactNode } from 'react';
import { testStudents } from '../data/testStudents';
import { Student } from '../types';

interface User {
  id: string;
  name: string;
  email: string;
  role: 'admin' | 'student';
  studentData?: Student;
}

interface AuthContextType {
  user: User | null;
  login: (email: string, password: string) => Promise<boolean>;
  loginAsStudent: (studentId: string) => void;
  logout: () => void;
  isAuthenticated: boolean;
  isStudent: boolean;
  isAdmin: boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);

  const login = async (email: string, password: string): Promise<boolean> => {
    if (email && password) {
      setUser({
        id: '1',
        name: '관리자',
        email: email,
        role: 'admin'
      });
      return true;
    }
    return false;
  };

  const loginAsStudent = (studentId: string) => {
    const student = testStudents.find(s => s.id === studentId);
    if (student) {
      setUser({
        id: student.id,
        name: student.name,
        email: student.email,
        role: 'student',
        studentData: student
      });
    }
  };

  const logout = () => {
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{
      user,
      login,
      loginAsStudent,
      logout,
      isAuthenticated: !!user,
      isStudent: user?.role === 'student',
      isAdmin: user?.role === 'admin'
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};